import React, { useEffect } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import Navbar from "./Navbar";
import Footer from "./Footer";

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />

      {/* Banner */}
      <div className="text-center" style={{ backgroundColor: "#ffffff", paddingTop: '7rem', paddingBottom: '3rem' }}>
        <Container>
          <h1 className="fw-bold">About Us</h1>
          <p className="text-muted mt-2">
            Building intelligent tools for transparent, high-impact E&S work
          </p>
        </Container>
      </div>

      {/* Main Content */}
      <Container className="py-5">
        {/* Mission */}
        <Row className="mb-5">
          <Col lg={8} className="mx-auto">
            <h2 className="fw-semibold mb-3">
              Our Mission: Bridging the Expertise Gap
            </h2>
            <p className="text-muted">
              E&S Solutions is a woman-owned tech-forward firm founded in 2024 with
              a singular mission: to modernize Environmental and Social (E&S)
              performance through intelligent engineering. We build the tools we
              wish we had as practitioners — designed to eliminate data overload,
              solve the trust deficit, and turn fragmented reports into active,
              transparent dialogues.
            </p>
          </Col>
        </Row>

        {/* Story */}
        <Row className="mb-5">
          <Col lg={8} className="mx-auto">
            <h3 className="fw-semibold mb-3">
              The Story: From Insider Frustration to Innovation
            </h3>
            <p className="text-muted">
              The E&S industry has long been burdened by data overload — critical
              information buried in 100+ page PDFs that are difficult to search,
              interpret, and act upon. While AI was transforming other sectors,
              E&S was being left behind.
            </p>
            <p className="text-muted">
              Our founder, Ildiko Almasi Simsic, created E&S Solutions to
              streamline the technical heavy lifting of research and information
              gathering, empowering professionals to focus on what matters most:
              high-quality analysis, strategic decisions, and real-world impact.
              Automation, workflow-driven software, and AI-centred approaches are
              at the core of everything we build.
            </p>
          </Col>
        </Row>

        {/* Product Evolution */}
        <Row className="mb-5">
          <Col lg={10} className="mx-auto">
            <h3 className="fw-semibold mb-4 text-center">
              Our Product Evolution
            </h3>

            <Row className="g-4">
              <Col md={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body>
                    <h5 className="fw-semibold">For Practitioners</h5>
                    <p className="text-muted mb-0">
                      Agents like myESRA™ and privatESRA deliver verified, fully
                      cited answers backed by a comprehensive E&S knowledge base.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body>
                    <h5 className="fw-semibold">For Transparency</h5>
                    <p className="text-muted mb-0">
                      DiscloseAI transforms static corporate disclosures into
                      dynamic dialogues, defending against greenwashing by
                      linking every claim to a source.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body>
                    <h5 className="fw-semibold">For Advanced Analytics</h5>
                    <p className="text-muted mb-0">
                    Deep learning for stakeholder sentiment analysis and
                      scenario modelling to support strategic environmental
                      assessments.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={3}>
                <Card className="h-100 border-0 shadow-sm">
                  <Card.Body>
                    <h5 className="fw-semibold">For Developers</h5>
                    <p className="text-muted mb-0">
                    SmartEIA speeds up permitting while maintaining human control over the final product.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* Founder */}
        <Row className="mb-5">
          <Col lg={8} className="mx-auto">
            <h3 className="fw-semibold mb-3">Meet the Founder</h3>
            <h5 className="fw-semibold">
              Ildiko Almasi Simsic
            </h5>
            <p className="text-muted fst-italic">
              Social Development Specialist & E&S Tech Pioneer
            </p>

            <p className="text-muted">
              Ildiko is a seasoned social development specialist with nearly 18
              years of experience leading high-risk, complex projects across five
              continents. Her work spans major International Financial
              Institutions including IFC, World Bank, EBRD, and AIIB.
            </p>
            <p className="text-muted">
              She is a recognized authority in social impact management, labor,
              and supply chain safeguards. Beyond the tech space, she is the
              author of the award-winning book <em>What is a Social Impact?</em>,
              a frequent contributor to Forbes, Reuters, and Fast Company, and
              the host of <em>The No Nonsense Sustainability Podcast</em>.
            </p>
          </Col>
        </Row>

        {/* Links */}
        <Row>
          <Col lg={8} className="mx-auto text-center">
            <h4 className="fw-semibold mb-3">Connect & Explore</h4>
            <p>
              <a
                href="https://www.ildiko-almasi.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                ildiko-almasi.com
              </a>
            </p>
            <p>
              <a
                href="https://www.whatisasocialimpact.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                whatisasocialimpact.com
              </a>
            </p>
            <p>
              <a
                href="https://linktr.ee/thenononsensesustainability"
                target="_blank"
                rel="noopener noreferrer"
              >
                The No Nonsense Sustainability Podcast
              </a>
            </p>
          </Col>
        </Row>
      </Container>

      <Footer />
    </>
  );
};

export default AboutUs;
